import { useState, useEffect, useCallback } from 'react';
import { getRequest, postRequest, putRequest, deleteRequest, showMessage } from '../../../config';

export const useDashboardCards = () => {
    const [cards, setCards] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchCards = useCallback(async () => {
        setIsLoading(true);
        try {
            const response = await getRequest('/modules/dashboard-cards');
            if (response && response.code === 200) {
                const body = response.body || {};
                setCards(Array.isArray(body.cards) ? body.cards : []);
            } else {
                setCards([]);
            }
        } catch (error) {
            console.error('Error fetching dashboard cards:', error);
            showMessage('Failed to load dashboard cards');
            setCards([]);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchCards();
    }, [fetchCards]);

    const createCard = async (data) => {
        try {
            const res = await postRequest('/modules/dashboard-cards', data);
            if (res && res.code === 200) {
                showMessage(res.message || 'Dashboard card created successfully');
                await fetchCards();
                return { success: true, data: res.body };
            }
            showMessage(res?.message || 'Failed to create dashboard card');
            return { success: false };
        } catch (error) {
            console.error('Error creating dashboard card:', error);
            showMessage('Failed to create dashboard card');
            return { success: false };
        }
    };

    const updateCard = async (data) => {
        try {
            const res = await putRequest('/modules/dashboard-cards', data);
            if (res && res.code === 200) {
                showMessage(res.message || 'Dashboard card updated successfully');
                await fetchCards();
                return { success: true, data: res.body };
            }
            showMessage(res?.message || 'Failed to update dashboard card');
            return { success: false };
        } catch (error) {
            console.error('Error updating dashboard card:', error);
            showMessage('Failed to update dashboard card');
            return { success: false };
        }
    };

    const deleteCard = async (id) => {
        try {
            const res = await deleteRequest(`/modules/dashboard-cards/${id}`);
            if (res && res.code === 200) {
                showMessage(res.message || 'Dashboard card deleted successfully');
                await fetchCards();
                return true;
            }
            showMessage(res?.message || 'Failed to delete dashboard card');
            return false;
        } catch (error) {
            console.error('Error deleting dashboard card:', error);
            showMessage('Failed to delete dashboard card');
            return false;
        }
    };

    return {
        cards,
        isLoading,
        fetchCards,
        createCard,
        updateCard,
        deleteCard
    };
};
